import { useState, useEffect, useCallback } from 'react';
import { useCookies } from 'react-cookie';
import { isBannerAcceptedCookieExistInDocument, isTrackingViaCookiesEnabled, trackWithAnalyticsService as trackWithAnalyticsService$1, getDefaultAnalyticsProps, ANALYTICS_SERVICE_URL } from '../../helpers/tracking.esm.js';
import { useAnalyticsContext } from '../../providers/AnalyticsProvider.esm.js';
import { View } from './types.esm.js';
import { useComplianceProvider, allCookiesType, defaultCookieType } from '../../providers/ComplianceProvider.esm.js';
import { getEnv } from '../../helpers/infra.esm.js';
import { ApiRoute } from '../../config/api.esm.js';
import { Cookie } from '../../config/cookies.esm.js';
import { Client } from '../../helpers/client/client.esm.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
// Track with internal analytics service to check cookie banner interactions
var trackWithAnalyticsService = function(param) {
    var eventName = param.eventName, cookieProps = param.cookieProps, geo = param.geo;
    trackWithAnalyticsService$1({
        eventName: eventName,
        props: _object_spread({}, getDefaultAnalyticsProps()),
        cookieProps: _object_spread({}, cookieProps, geo != null ? {
            region: geo.split("-")[1],
            country: geo.split("-")[0]
        } : {}),
        reportingUrl: ANALYTICS_SERVICE_URL[getEnv()]
    });
};
function postCookieConsent(param) {
    var baseUrl = param.baseUrl, isCookieAccepted = param.isCookieAccepted, _param_enabledCookiesList = param.enabledCookiesList, enabledCookiesList = _param_enabledCookiesList === void 0 ? defaultCookieType : _param_enabledCookiesList, _param_email = param.email, email = _param_email === void 0 ? null : _param_email;
    var body = {
        accept: isCookieAccepted,
        cookieTypes: enabledCookiesList.toString(),
        emailToRemove: email
    };
    Client.post("".concat(baseUrl).concat(ApiRoute.PrivacyBannerAcceptCookies), body, {
        withCredentials: true
    }).catch(function() {
    // do nothing
    });
}
function useCookieConsent(param) {
    var onClose = param.onClose, onAccept = param.onAccept, onDecline = param.onDecline, baseUrl = param.baseUrl;
    var _useAnalyticsContext = useAnalyticsContext(), activateTracking = _useAnalyticsContext.activateTracking, trackEvent = _useAnalyticsContext.trackEvent, initialCookieAccepted = _useAnalyticsContext.cookieBannerAccepted;
    var _useComplianceProvider = useComplianceProvider(), cookieTypesEnabledList = _useComplianceProvider.cookieTypesEnabledList, isPersonalInfoView = _useComplianceProvider.isPersonalInfoView, isConsentBannerShown = _useComplianceProvider.isConsentBannerShown, setShowConsentBanner = _useComplianceProvider.setShowConsentBanner, isCCPA = _useComplianceProvider.isCCPA;
    var _useCookies = _sliced_to_array(useCookies([
        Cookie.Geography
    ]), 1), cookies = _useCookies[0];
    var geo = cookies[Cookie.Geography];
    var _useState = _sliced_to_array(useState(View.Information), 2), view = _useState[0], setView = _useState[1];
    var _useState1 = _sliced_to_array(useState(initialCookieAccepted !== null && initialCookieAccepted !== void 0 ? initialCookieAccepted : true), 2), isCookieAccepted = _useState1[0], setIsCookieAccepted = _useState1[1];
    var _useState2 = _sliced_to_array(useState(cookieTypesEnabledList), 2), cookieTypesEnabledState = _useState2[0], setCookieTypesEnabledState = _useState2[1];
    useEffect(function() {
        if (isPersonalInfoView) {
            setView(View.Customize);
        }
    }, [
        isPersonalInfoView
    ]);
    useEffect(function() {
        setCookieTypesEnabledState(cookieTypesEnabledList);
    }, [
        cookieTypesEnabledList
    ]);
    var closeBanner = useCallback(function() {
        setShowConsentBanner(false);
        setView(View.Information);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [
        onClose,
        setShowConsentBanner
    ]);
    var navigateToCustomizeView = useCallback(function() {
        setView(View.Customize);
        trackEvent("cookie_consent.move_to_customize_view");
        trackWithAnalyticsService({
            geo: geo,
            eventName: "cookie_consent.interacted",
            cookieProps: {
                action: "move to customize"
            }
        });
    }, [
        trackEvent,
        geo
    ]);
    var navigateToInformationView = useCallback(function() {
        setView(View.Information);
        trackEvent("cookie_consent.move_to_information_view");
    }, [
        trackEvent
    ]);
    var onInternalDecline = useCallback(function() {
        onDecline === null || onDecline === void 0 ? void 0 : onDecline();
    }, [
        onDecline
    ]);
    var onConfirm = useCallback(function(param) {
        var isAcceptAll = param.isAcceptAll, email = param.email;
        if (isAcceptAll) {
            setCookieTypesEnabledState(allCookiesType);
        }
        var canTrack = isAcceptAll || cookieTypesEnabledState.includes("analytics");
        var enabledCookiesList = isAcceptAll ? allCookiesType : cookieTypesEnabledState;
        var _email_replaceAll;
        var cleanedEmail = (_email_replaceAll = email === null || email === void 0 ? void 0 : email.replaceAll(/\s/g, "")) !== null && _email_replaceAll !== void 0 ? _email_replaceAll : "";
        var finalEmail = isAcceptAll ? null : cleanedEmail === "" ? null : cleanedEmail;
        setIsCookieAccepted(canTrack);
        postCookieConsent({
            baseUrl: baseUrl,
            isCookieAccepted: canTrack,
            enabledCookiesList: enabledCookiesList,
            email: finalEmail
        });
        trackWithAnalyticsService({
            geo: geo,
            eventName: "cookie_consent.interacted",
            cookieProps: {
                cookies: enabledCookiesList.toString(),
                action: view === View.Information ? "accept" : "confirm"
            }
        });
        trackEvent("cookie_consent.click_".concat(view === View.Information ? "accept" : "confirm"));
        onAccept === null || onAccept === void 0 ? void 0 : onAccept();
        if (canTrack) {
            activateTracking();
        } else {
            onInternalDecline();
        }
        closeBanner();
    }, [
        baseUrl,
        trackEvent,
        view,
        closeBanner,
        activateTracking,
        onAccept,
        onInternalDecline,
        cookieTypesEnabledState,
        geo
    ]);
    var onReject = useCallback(function() {
        postCookieConsent({
            baseUrl: baseUrl,
            isCookieAccepted: false,
            enabledCookiesList: [
                "essential"
            ]
        });
        trackWithAnalyticsService({
            geo: geo,
            eventName: "cookie_consent.interacted",
            cookieProps: {
                cookies: "essential",
                action: "reject"
            }
        });
        setIsCookieAccepted(false);
        setCookieTypesEnabledState([
            "essential"
        ]);
        trackEvent("cookie_consent.click_reject_consent");
        onInternalDecline();
        closeBanner();
    }, [
        baseUrl,
        trackEvent,
        closeBanner,
        onInternalDecline,
        geo
    ]);
    useEffect(function() {
        if (!isBannerAcceptedCookieExistInDocument() && !isTrackingViaCookiesEnabled()) {
            trackEvent("cookie_consent.show");
            trackWithAnalyticsService({
                geo: geo,
                eventName: "cookie_consent.viewed"
            });
        }
    }, [
        trackEvent,
        baseUrl,
        geo
    ]);
    return {
        currentView: view,
        isClosed: !isConsentBannerShown,
        isCookieAccepted: isCookieAccepted,
        navigateToCustomizeView: navigateToCustomizeView,
        navigateToInformationView: navigateToInformationView,
        onConfirmHandler: onConfirm,
        cookieTypesEnabledState: cookieTypesEnabledState,
        setCookieTypesEnabledState: setCookieTypesEnabledState,
        onRejectHandler: onReject,
        isCCPA: isCCPA,
        isPersonalInfoView: isPersonalInfoView
    };
}

export { useCookieConsent };
